<template>
    <div>
        <!-- 🔼 Header -->
        <div class="slide mb-5" style="margin-top: 74px !important;">
            <div class="bg-img">
                <div class="slide-content">
                    <div>
                        <h2 class="slide-header">{{ 'Inventory' }}</h2>
                    </div>
                    <div>
                        <h5 class="slide-h5">{{ $t('message.home') }}</h5>
                        <b-icon :icon="isRTL ? 'chevron-double-left' : 'chevron-double-right'" class="icon-slider" />
                        <h5 class="slide-h5">{{ 'Inventory' }}</h5>
                        <b-icon :icon="isRTL ? 'chevron-double-left' : 'chevron-double-right'" class="icon-slider" />
                        <h5 class="slide-h5">{{ 'Inventory-details' }}</h5>

                    </div>
                </div>
            </div>
        </div>
        <div class="container mt-4">
            <h3 class="mb-4 text-center">
                <b-icon icon="people-fill" class="mr-2 text-primary" />
                Inventory Assigned Users
            </h3>

            <div v-if="inventory && !hasInventoryStarted">
                <b-alert :show="true" variant="info" class="text-center py-4">
                    <b-icon icon="clock-history" class="mr-2" />
                    <strong>Inventory starts in:</strong>

                    <div class="d-flex justify-content-center mt-3 flex-wrap">
                        <div v-for="(item, index) in timeLeftArray" :key="index"
                            class="mx-2 text-center px-3 py-2 border rounded bg-light" style="min-width: 80px;">
                            <h4 class="mb-1 text-primary">{{ item.value }}</h4>
                            <small class="text-muted">{{ item.label }}</small>
                        </div>
                    </div>
                </b-alert>
            </div>
            <div v-if="hasInventoryStarted">
                <b-alert :show="true" variant="success" class="text-center">
                    <b-icon icon="check-circle-fill" class="mr-2" />
                    <strong>Inventory has started. You can now show result.</strong>
                </b-alert>
            </div>





            <div v-if="isLoading" class="text-center my-5">
                <b-spinner variant="primary" label="Loading..." />
            </div>

            <div v-else>




                <b-row>
                    <!-- Technicians -->
                    <b-col md="4" v-if="groupedUsers.technicals.length">
                        <b-card header="👨‍🔧 Technicians" class="shadow-sm" style="border-radius: 10px;">
                            <b-list-group flush>
                                <b-list-group-item v-for="user in groupedUsers.technicals" :key="user.id"
                                    class="d-flex align-items-center justify-content-between" style="cursor: pointer">
                                    <div class="d-flex align-items-center">
                                        <b-icon icon="person-badge-fill" class="mr-2 text-info" />
                                        <div class="d-flex flex-column">
                                            <strong>{{ user.name }}</strong>
                                            <small class="text-muted">{{ user.phone }}</small>
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center">
                                        <b-badge
                                            :variant="user.user_status === '1' ? 'success' : (user.user_status === '2' ? 'danger' : 'warning')"
                                            class="ml-2">
                                            {{
                                                user.user_status === '1'
                                                    ? 'Accepted'
                                                    : user.user_status === '2'
                                                        ? 'Rejected'
                                                        : 'Pending'
                                            }}
                                        </b-badge>



                                    </div>
                                </b-list-group-item>
                            </b-list-group>
                        </b-card>
                    </b-col>

                    <!-- Admins -->
                    <b-col md="4" v-if="groupedUsers.admins.length">
                        <b-card header="🛡️ Admins" class="shadow-sm" style="border-radius: 10px;">
                            <b-list-group flush>
                                <b-list-group-item v-for="user in groupedUsers.admins" :key="user.id"
                                    class="d-flex align-items-center justify-content-between" style="cursor: pointer">
                                    <div class="d-flex align-items-center">
                                        <b-icon icon="shield-lock-fill" class="mr-2 text-warning" />
                                        <div class="d-flex flex-column">
                                            <strong>{{ user.name }}</strong>
                                            <small class="text-muted">{{ user.phone }}</small>
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center">
                                        <b-badge
                                            :variant="user.user_status === '1' ? 'success' : (user.user_status === '2' ? 'danger' : 'warning')"
                                            class="ml-2">
                                            {{
                                                user.user_status === '1'
                                                    ? 'Accepted'
                                                    : user.user_status === '2'
                                                        ? 'Rejected'
                                                        : 'Pending'
                                            }}
                                        </b-badge>



                                    </div>
                                </b-list-group-item>
                            </b-list-group>
                        </b-card>
                    </b-col>

                    <!-- Company Users -->
                    <b-col md="4" v-if="groupedUsers.company.length">
                        <b-card header="🏢 Company Users" class="shadow-sm" style="border-radius: 10px;">
                            <b-list-group flush>
                                <b-list-group-item v-for="user in groupedUsers.company" :key="user.id"
                                    class="d-flex align-items-center justify-content-between" style="cursor: pointer">
                                    <div class="d-flex align-items-center">
                                        <b-icon icon="building" class="mr-2 text-success" />
                                        <div class="d-flex flex-column">
                                            <strong>{{ user.name }}</strong>
                                            <small class="text-muted">{{ user.phone }}</small>
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center">
                                        <b-badge
                                            :variant="user.user_status === '1' ? 'success' : (user.user_status === '2' ? 'danger' : 'warning')"
                                            class="ml-2">
                                            {{
                                                user.user_status === '1'
                                                    ? 'Accepted'
                                                    : user.user_status === '2'
                                                        ? 'Rejected'
                                                        : 'Pending'
                                            }}
                                        </b-badge>

                                        <!-- <b-button v-if="user.user_status === '2'" size="sm" variant="outline-primary"
                                            class="ml-2 resend-btn" @click.stop="resendInvitation(user)">
                                            Resend
                                        </b-button> -->

                                    </div>
                                </b-list-group-item>
                            </b-list-group>
                        </b-card>
                    </b-col>
                </b-row>

            </div>

        </div>

        <!-- 📦 Items Table Section -->
        <div v-if="hasInventoryStarted" class="container mt-5">
            <h4 class="mb-3">
                <b-icon icon="box-seam" class="mr-2 text-primary" />
                Inventory Result
            </h4>

            <div v-if="hasResults">
                <!-- الفلتر -->
                <div class="mb-3">
                    <label class="mb-1">فلترة بالفرق:</label>
                    <v-select v-model="selectedDifferenceType" :options="differenceOptions" label="label"
                        :reduce="option => option.value" placeholder="اختر نوع الفرق" class="w-100"
                        @input="onDifferenceFilterChange" />
                </div>

                <!-- الجدول -->
                <b-table responsive striped bordered class="invoice-table mt-4 custom-body" :items="userResults"
                    :fields="resultsFields" :per-page="resultsPerPage" :current-page="resultsCurrentPage"
                    :busy="loadingResults">
                    <template #table-busy>
                        <div class="text-center my-3">
                            <b-spinner variant="primary" />
                        </div>
                    </template>

                    <template #table-caption>
                        <div class="d-flex align-items-center pagination-section justify-content-between">
                            <select class="form-control form-control-sm w-auto" v-model="resultsPerPage"
                                @change="onResultsPerPageChange">
                                <option v-for="n in [5, 10, 20, 50]" :key="n" :value="n">{{ n }}</option>
                            </select>

                            <b-pagination pills size="sm" class="mb-0" :total-rows="resultsTotalRows"
                                v-model="resultsCurrentPage" :per-page="resultsPerPage" @change="loadUserResults" />
                        </div>
                    </template>
                </b-table>
                <!-- زر الموافقة وعدم الموافقة -->
                <div v-if="is_assignee && user_acceptance == 0" class="text-center mt-4">
                    <b-button variant="success" class="mx-2" @click="handleApproval('approve')">
                        <b-icon icon="check-circle-fill" class="mr-1" />
                        Approve Inventory
                    </b-button>

                    <b-button variant="danger" class="mx-2" @click="handleApproval('disapprove')">
                        <b-icon icon="x-circle-fill" class="mr-1" />
                        Disapprove Inventory
                    </b-button>
                </div>

                <!-- في حالة الضغط على أي زر -->
                <div v-if="actionType" class="mt-4">
                    <b-form-group label="Reason:">
                        <b-form-textarea v-model="rejectionReason" rows="3" placeholder="Write your reason here..." />
                    </b-form-group>

                    <div class="text-center">
                        <b-button variant="primary" @click="submitDecision">
                            <b-icon icon="send" class="mr-1" />
                            Submit
                        </b-button>
                    </div>
                </div>


            </div>

            <div v-else class="alert alert-warning text-center mt-4">
                <b-icon icon="info-circle-fill" class="mr-2 text-warning" />
                لم يتم إدخال نتائج الجرد بعد.
            </div>
        </div>


        <!-- <b-modal id="user-results-modal" size="xl" v-model="showResultsModal" title="📋 Inventory User Results"
            scrollable>


        </b-modal> -->

    </div>
</template>



<script>
import { mapGetters } from 'vuex';
import axiosInstance from '../axios-config';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
    components: {
        vSelect
    },
    data() {
        return {
            users: [],
            groupedUsers: {
                technicals: [],
                admins: [],
                company: [],
            },
            isLoading: false,
            inventoryId: null,
            storeId: null, // ← غيّرها حسب حالتك
            items: [],
            isItemsLoading: false,
            currentPage: 1,
            perPage: 5,
            perPageOptions: [2, 5, 10, 20],
            totalRows: 0,
            fields: [
                { key: "desc_ar", label: "Item Name (AR)" },
                { key: "uom", label: "UOM" },
                //   { key: "totalQuantity", label: "Actual Available Quantity" },
                // 👇 يتم إضافة هذا الحقل فقط لو في أي قيمة فعلاً
                { key: "foundQuantity", label: "Found Quantity" } // 👈 الجديد
            ],
            submitted: false,
            showResultsModal: false,
            userResults: [],
            selectedUser: null,
            // selectedDifferenceType: 0,
            loadingResults: false,
            resultsFields: [
                { key: "desc_ar", label: "Item Name" },
                { key: "inventoryQuantity", label: "Inventory Qty" },
                { key: "old_quantity", label: "Old Qty" },
                { key: "difference", label: "Difference" },
            ],
            // 🧾 Pagination متغيرات
            resultsCurrentPage: 1,
            resultsPerPage: 10,
            resultsTotalRows: 0,
            resultsPerPageOptions: [5, 10, 20, 50],
            selectedDifferenceType: { label: "كل النتائج", value: "0" },
            differenceOptions: [
                { label: "كل النتائج", value: "0" },
                { label: "فقط الفرق ≠ 0", value: "1" },
                { label: "فرق موجب (> 0)", value: "2" },
                { label: "فرق سالب (< 0)", value: "3" },
                { label: "فرق = 0", value: "4" },
            ],
            inventory: null,
            now: new Date(),
            timer: null,
            hasResults: false,
            actionType: null, // 'approve' أو 'disapprove'
            rejectionReason: '',
            is_assignee: false,
            user_acceptance: null,
        };
    },
    computed: {
        ...mapGetters(['getUser']),
        user() {
            return this.getUser;
        },
        canSubmitResults() {
            return this.items.every(item => item.foundQuantity !== null && item.foundQuantity !== '');
        },
        isRTL() {
            return this.$i18n.locale === 'ar';
        },
        rejectedCount() {
            return this.users.filter(user => user.user_status === "0" || user.user_status === "2").length;
        },
        hasInventoryStarted() {
            if (!this.inventory || !this.inventory.due_date) return false;
            const now = this.now;
            const due = new Date(this.inventory.due_date);
            return now >= due;
        },
        timeLeftArray() {
            if (!this.inventory || !this.inventory.due_date) return [];

            const due = new Date(this.inventory.due_date);
            const now = this.now;
            const diff = due - now;

            if (diff <= 0) return [];

            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((diff / (1000 * 60)) % 60);
            const seconds = Math.floor((diff / 1000) % 60);

            return [
                { label: 'Days', value: days },
                { label: 'Hours', value: hours },
                { label: 'Minutes', value: minutes },
                { label: 'Seconds', value: seconds },
            ];
        }

    },
    created() {

        this.timer = setInterval(() => {
            this.now = new Date();
        }, 1000);
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    async mounted() {
        this.inventoryId = this.$route.params.inventory_id;
        await this.fetchInventoryDetails();
        this.fetchInventoryUsers(this.inventoryId);
        // this.loadItems();
        console.log(this.hasInventoryStarted);

        if (this.hasInventoryStarted) {
            this.selectedDifferenceType = 0;
            this.hasResults = await this.loadUserResults(this.user?.id);
        }
    },
    methods: {
        async fetchInventoryDetails() {
            try {
                const res = await axiosInstance.get(`store/select_inventory_by_id.php`, {
                    params: { inventory_id: this.inventoryId }
                });

                if (res.data.status === 'true') {
                    this.inventory = res.data.output; // كائن مباشر مش array
                    this.storeId = res.data.output.store_id;
                }
            } catch (err) {
                console.error("Failed to fetch inventory details", err);
            }
        },



        async fetchInventoryUsers(id) {
            this.isLoading = true;
            try {
                const res = await axiosInstance.get(`store/select_inventory_users.php?inventory_id=${id}`);
                if (res.data.status === "true") {
                    this.users = res.data.output;
                    console.log('All user IDs from API:', this.users.map(u => u.user_id));


                    const currentUserId = String(this.user.id);
                    console.log('Current user ID from Vuex or data:', this.user?.id);

                    const currentUser = this.users.find(user => user.user_id === String(currentUserId));



                    console.log('User ID from auth:', this.user.id);
console.log('Users from API:', this.users);
                    console.log('11', currentUser);
                    
                    if (currentUser) {
                        this.user_acceptance = currentUser.user_status;
                        this.user_comment = currentUser.comments || '';
                        console.log('this.user_acceptance', this.user_acceptance);
                        
                    } else {
                        // المستخدم مش ضمن الجرد الحالي
                        this.user_acceptance = null;
                        this.user_comment = '';
                    }

                    this.groupUsers(); // تقسيم المستخدمين حسب النوع مثلاً
                }
            } catch (err) {
                console.error("Error loading users", err);
            } finally {
                this.isLoading = false;
            }
        },

        groupUsers() {
            const uniqueById = (users) => {
                const seen = new Set();
                return users.filter(user => {
                    if (seen.has(user.id)) return false;
                    seen.add(user.id);
                    return true;
                });
            };

            this.groupedUsers.technicals = uniqueById(this.users.filter(u => u.type === "0"));
            this.groupedUsers.admins = uniqueById(this.users.filter(u => u.type === "1"));
            this.groupedUsers.company = uniqueById(this.users.filter(u => u.type === "2"));
        },
        // async loadItems() {
        //     this.isItemsLoading = true;
        //     const formData = new FormData();
        //     formData.append("page", this.currentPage);
        //     formData.append("page_size", this.perPage);
        //     formData.append("store_id", this.storeId);
        //     formData.append("inventory_id", this.inventoryId);

        //     try {
        //         const res = await axiosInstance.post("store/select_quantity_inventory.php", formData);
        //         if (res.data.status === "true") {
        //             this.items = res.data.output.map(item => ({
        //                 ...item,
        //                 foundQuantity: null // 👈 يبدأ بقيمة فاضية
        //             }));


        //             // 👇 إضافة العمود إذا وُجد أي عنصر يحتوي على totalQuantity
        //             const hasQuantities = this.items.some(item => item.totalQuantity !== null);
        //             if (hasQuantities && !this.fields.find(f => f.key === "totalQuantity")) {
        //                 this.fields.push({
        //                     key: "totalQuantity",
        //                     label: "Actual Available Quantity",
        //                 });
        //             }

        //             // 📦 تحديث بيانات الصفحات
        //             const pagination = res.data.pagination;
        //             this.totalRows = parseInt(pagination.total_products);
        //         }
        //     } catch (err) {
        //         console.error("Error fetching inventory items:", err);
        //     } finally {
        //         this.isItemsLoading = false;
        //     }
        // },


        onDifferenceFilterChange() {
            this.resultsCurrentPage = 1;
            this.loadUserResults(this.selectedUserId);
        },
        onResultsPerPageChange() {
            this.resultsCurrentPage = 1;
            this.loadUserResults(this.selectedUserId);
        },
        async loadUserResults(userId) {


            this.loadingResults = true;

            const formData = new FormData();
            formData.append("page", this.resultsCurrentPage);
            formData.append("page_size", this.resultsPerPage);

            const params = {
                inventory_id: this.inventoryId,
                user_id: userId,
                store_id: this.storeId,
                type: 1,
                difference_type: this.selectedDifferenceType
            };

            try {
                const res = await axiosInstance.post("store/select_inventory_user_result.php", formData, { params });
                if (res.data.status === "true") {
                    this.userResults = res.data.output;
                    this.is_assignee = res.data.is_assignee;
                    this.resultsTotalRows = parseInt(res.data.pagination?.total_products || 0);
                    return this.userResults.length > 0;
                } else {
                    this.userResults = [];
                    this.resultsTotalRows = 0;
                    return false;
                }
            } catch (err) {
                console.error("Error loading user results:", err);
                this.userResults = [];
                this.resultsTotalRows = 0;
                return false;
            } finally {
                this.loadingResults = false;
            }
        },



        changePage(page) {
            this.currentPage = page;
            // this.loadItems();
        },

        onPerPageChange() {
            this.currentPage = 1;
            // this.loadItems();
        },

        handleScroll(event) {
            event.preventDefault();
            if (event.deltaY < 0 && this.currentPage > 1) {
                this.changePage(this.currentPage - 1);
            } else if (event.deltaY > 0 && this.currentPage < Math.ceil(this.totalRows / this.perPage)) {
                this.changePage(this.currentPage + 1);
            }
        },
        async resendInvitation(user) {
            const formData = new FormData();
            formData.append("inventory_id", this.inventoryId);
            formData.append("user_id", user.id);
            formData.append("user_status", 0); // إعادة إرسال = موافقة

            try {
                await axiosInstance.post("store/update_inventory_user_acceptance.php", formData);
                this.$izitoast.success({
                    title: "Success",
                    message: "Invitation resent and status updated to Accepted",
                    position: "bottomLeft",
                });
                // this.fetchInventoryUsers(this.inventoryId); // تحديث القائمة
            } catch (error) {
                this.$izitoast.error({
                    title: "Error",
                    message: "Failed to resend invitation",
                    position: "bottomLeft",
                });
            }
        },
        handleApproval(type) {
            this.actionType = type;
            this.rejectionReason = ''; // reset textarea
        },
        async submitDecision() {
            if (!this.rejectionReason.trim()) {
                this.$izitoast.warning({
                    title: 'Warning',
                    message: 'Please enter a reason.',
                    position: 'bottomLeft'
                });
                return;
            }

            const formData = new FormData();
            formData.append('inventory_id', this.inventoryId);
            formData.append('user_id', this.user.id); // 👈 ID بتاع اليوزر الحالي
            formData.append('user_status', this.actionType === 'approve' ? '1' : '2');
            formData.append('comments', this.rejectionReason);

            try {
                const res = await axiosInstance.post('store/update_inventory_user_acceptance.php', formData);

                if (res.data.status === 'true') {
                    this.$izitoast.success({
                        title: 'Success',
                        message: this.actionType === 'approve' ? 'Inventory approved successfully.' : 'Disapproval sent successfully.',
                        position: 'bottomLeft'
                    });
                } else {
                    throw new Error(res.data.message || 'Something went wrong.');
                }
            } catch (err) {
                console.error('Submission error:', err);
                this.$izitoast.error({
                    title: 'Error',
                    message: 'Failed to submit your decision.',
                    position: 'bottomLeft'
                });
            } finally {
                // Reset
                this.actionType = null;
                this.rejectionReason = '';
            }
        }




    }
};



</script>

<style scoped>
.badge,
.resend-btn {
    height: 24px !important;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>